import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { COMPANY } from '../../containers/TvpLayout/Footer/Footer';
import { isModifiedClick, partnerHost } from './partnerUrl';
import classes from './PartnerLink.module.scss';

const TITLE_ID = 'partner-leave-title';

// Link zakupu na stronie ubezpieczyciela, jak PartnerLink na uspartner.pl: nowa karta,
// a najpierw okienko, dokąd klient przechodzi, z numerem infolinii —
// żeby wyjście z portalu nie wyglądało na błąd.
const PartnerLink = ({ children, className, discount, href, partner }) => {
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  const host = partnerHost(href);

  const onClick = (event) => {
    if (!host || isModifiedClick(event)) {
      return;
    }
    event.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <a
        className={className}
        href={href}
        onClick={onClick}
        rel="noopener noreferrer"
        target="_blank">
        {children}
      </a>
      {open && (
        <LeaveDialog
          discount={discount}
          host={host}
          href={href}
          onClose={close}
          partner={partner}
        />
      )}
    </>
  );
};

const LeaveDialog = ({ discount, host, href, onClose, partner }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    // Jak natywny <dialog> na USP: fokus na ×, Escape zamyka, po zamknięciu fokus wraca na link
    const previous = document.activeElement;
    closeRef.current.focus();

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      if (previous && previous.focus) {
        previous.focus();
      }
    };
  }, [onClose]);

  // Portal do <body>: kafelki mają overflow: hidden i transform na hover
  return ReactDOM.createPortal(
    <div className={classes.overlay} onClick={onClose} role="presentation">
      <div
        className={classes.box}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={TITLE_ID}>
        <button
          ref={closeRef}
          type="button"
          className={classes.x}
          onClick={onClose}
          aria-label="Zamknij">
          ×
        </button>
        <p className={classes.title} id={TITLE_ID}>
          Za chwilę przejdziesz na stronę {partner}
        </p>
        <p className={classes.body}>
          {`Zakup i płatność odbywają się na bezpiecznej stronie ${partner} (${host}). `}
          Otworzy się w nowej karcie, a ta strona pozostanie otwarta.
        </p>
        {discount && <p className={classes.discount}>{discount}</p>}
        <p className={classes.help}>
          Masz pytanie? Zadzwoń do nas:{' '}
          <a href={COMPANY.phoneHref} className={classes.phone}>
            {COMPANY.phone}
          </a>{' '}
          <span className={classes.hours}>({COMPANY.hours})</span>
        </p>
        <div className={classes.actions}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes.btn} ${classes.btnCta}`}
            onClick={onClose}>
            Przejdź do {partner}
            <span aria-hidden="true">↗</span>
          </a>
          <button
            type="button"
            className={`${classes.btn} ${classes.btnGhost}`}
            onClick={onClose}>
            Zostań na tej stronie
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PartnerLink;
